/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

const LazyAdobeSignIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-adobe-sign" */ './utils').then((m) => m.AdobeSignIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/adobe-sign/icon' },
);

const LazyAdobeSignSearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-adobe-sign-search-result" */ './utils').then(
			(m) => m.AdobeSignSearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/adobe-sign/search-result-icon' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const AdobeSignIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAdobeSignIconComponent />
	</Suspense>
);

export const AdobeSignSearchResultIcon = (): React.JSX.Element => (
	<Suspense fallback={null}>
		<LazyAdobeSignSearchResultIconComponent />
	</Suspense>
);
